import FaqAddContainer from './FaqAddContainer';
import FaqAddStore from './FaqAddStore';

export default FaqAddStore(FaqAddContainer);